import { render, staticRenderFns } from "./CreateModifierSet.vue?vue&type=template&id=b25199c4&scoped=true"
import script from "./CreateModifierSet.vue?vue&type=script&lang=js"
export * from "./CreateModifierSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25199c4",
  null
  
)

export default component.exports